export default "__VITE_ASSET__BLMgqaIc__"